import React, { useEffect, useRef } from "react";
import { inject, observer } from "mobx-react";

const MilestoneList = (props) => {
  const startId = useRef(null);
  const endId = useRef(null);

  let streamerType = window.location.href.split("/")[4];

  const end = () => {
    ["therm-container__expand", "milestone", "therm"].forEach(function (ids) {
      document.getElementById(ids).classList.add("deactive");
      document.getElementById(ids).classList.remove("active");
    });
  };

  const setActive = () => {
    ["therm-container__expand", "milestone", "therm"].forEach((ids) => {
      document.getElementById(ids).classList.add("active");
      document.getElementById(ids).classList.remove("deactive");
      endId.current = setTimeout(end, 10000);
    });
    console.log("i ran");
  };

  useEffect(() => {
    const { progress } = props.overlayStore;

    if (progress < 100) {
      startId.current = setInterval(setActive, 600000);
    } else {
      clearInterval(startId.current);
      clearTimeout(endId.current);
    }
    return () => {
      clearInterval(startId.current);
      clearTimeout(endId.current);
    };
  }, [props.overlayStore.progress]);

  const { goal, milestones, percent } = props.overlayStore;

  // const formatNumber = (num) => {
  //   let value = num;
  //   const res = String(num).split(".");
  //   if (res.length === 1 || res[1].length <= 3) {
  //     value = value
  //       .toFixed(2)
  //       .replace(/\.00$/, "")
  //       .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  //   }
  //   return value;
  // };

  const convertTwitchAmount = (amount, decPlaces) => {
    return parseInt(amount.toString().slice(0, -decPlaces));
  };

  const formatNumber = (num) => {
    return num.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  return (
    <div className="milestones" id="milestone">
      {milestones.map((milestone) => (
        <div
          key={milestone.id}
          className={`
              ${
                Math.floor(
                  100 * (parseFloat(milestone.amount.value) / parseFloat(goal))
                ) > percent
                  ? "milestones__text higher"
                  : "milestones__text lower"
              }
            `}
        >
          <div className="m_next">Next Milestone:</div>

          <div className="m_info">
            <span>
              ${formatNumber(milestone.amount.value)} - {milestone.name}
            </span>
          </div>
        </div>
      ))}
      <div className=" milestones__text higher">
        <div className="m_next">Next Milestone:</div>
        <div className="m_info">
          <span>
            Reach our goal of $
            {goal}
          </span>
        </div>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(MilestoneList));
